export default __webpack_public_path__ + "static/media/marker-label-You.b3c27fe5.svg";